export enum EventType {
  PreApprovalResult = 'PreApprovalResult'
}
